/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/requestFlightMiles/services/helper.js
*    TO   --> ./legacy-web/src/main/assets/js/request-flight-miles/services/helper.js
**/

var RFM_APP = angular.module("RFM_APP");

RFM_APP.service("helper", ["$location", function ($location) {

    var _this = this;

    this.errorHandler = function (jqXHR, $el, errorPagePath) {
        if (500 === jqXHR.status || 0 === jqXHR.status) {
            $el.show();
        } else {
            _this.redirect(errorPagePath);
        }
    };

    this.redirect = function (url) {
        top.location.href = url;
    };

    this.updateHash = function (hash) {
        $location.path(hash);
    };

    this.scrollToError = function ($el) {
        var firstErrorElmId = $el.attr("for");
        //redundancy, just to make sure it doesn't break anything if html has any problems.
        if (firstErrorElmId) {
            var $firstErrorElm = $j("#" + firstErrorElmId);
            //redundancy, just to make sure it doesn't break anything if html has any problems.
            if ($firstErrorElm.length) {
                $j("html, body").animate(
                    {
                        scrollTop: $firstErrorElm.offset().top - 100
                    }, 250, function () {
                        if ($firstErrorElm) {
                            $firstErrorElm.focus();
                        }
                    });
            }
        }
    };

    this.scrollToErrorSummary = function ($errorSummary) {

        $j("html, body").animate(
            {
                scrollTop: $errorSummary.offset().top - 100
            }, 250, function () {
                $errorSummary.focus();
            });

    };

    this.updatePageTitle = function (key) {
        $j("title").html(AAcom.prototype.getProperty(key));
    };

    this.isNumber = function (event) {

        var character = event.which ? event.which : event.keyCode;
        var keys = [8, 9, 13, 16, 17, 18, 19, 29, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 199, 100, 101, 102, 103, 104, 105];

        if ($j.inArray(character, keys) === -1 || (((character >= 48 && character <= 57) || (character >= 96 && character <= 105)) && (event.shiftKey || event.metaKey || event.ctrlKey))) {
            if (!((character === 65 || character === 67 || character === 86 || character === 88 ) && (event.metaKey || event.ctrlKey))) { //Support Select/Copy/Cut/Paste
                event.preventDefault();
                return false;
            }

        }

    };

}]);
